import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import SnapshotRating from './SnapshotRating';
import { ImageLazyLoad } from '../index';
import { QueryUrls, SnapshotGalleryContext } from '../../contexts/SnapshotGalleryContext';

const loaderProps = { style: { height: 50 }, dark: true };

export const SnapshotGalleryItem = ({
  dataSnapshotIndex,
  snapshot,
  toggleLightbox,
  favoriting,
  activeClass,
  toggleFavorite,
  authenticated
}) => {
  const { queryType } = useContext(SnapshotGalleryContext);
  const isContest = queryType === QueryUrls.CONTEST;
  const [cameraTime, setCameraTime] = useState();
  useEffect(() => {
    let tempCameraTime;
    if (snapshot.local_time && snapshot.timezone) {
      tempCameraTime = moment(snapshot.local_time)
        .tz(snapshot.timezone)
        .format('MMM D, YYYY h:mm A z');
    } else {
      tempCameraTime = moment(snapshot.created_at)
        .format('MMM D, YYYY h:mm A z');
    }
    setCameraTime(tempCameraTime);
  }, [snapshot.local_time, snapshot.created_at]);

  const overlayFavoriteToggle = (event) => {
    event.stopPropagation();
    toggleFavorite();
  };

  return (
    <div className="m-2 clickable">
      <div
        className="snapshot-thumb-wrap"
        data-snapshot-index={dataSnapshotIndex}
        data-uuid={snapshot.uuid}
        onClick={toggleLightbox}
      >
        {snapshot.youtube_id && (
          <a
            className="text-black p-1 snapshot-has-video"
            href={`https://youtube.com/watch?v=${snapshot.youtube_id}&t=${snapshot.youtube_delta}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <i
              className="fab fa-youtube clickable hover-red snapshot-has-video-icon"
              role="button"
              tabIndex={0}
            />
          </a>
        )}
        <div className="hover-overlay">
          <div className="favorite-wrap">
            {favoriting.includes(snapshot.uuid) ? (
              <i
                className="m-2 fa-spin fas fa-spinner no-outline"
                role="button"
                tabIndex={0}
              />
            ) : (
              <i
                className={`m-2 clickable no-outline fa-star favorite-heart ${activeClass}`}
                onClick={overlayFavoriteToggle}
                role="button"
                tabIndex={0}
              />
            )}
          </div>
          <div className="text-center w-100 p-2">
            {cameraTime}
          </div>
          {isContest && <div style={{ position: 'absolute', right: 5, bottom: 5 }}>
            <SnapshotRating
              rating={parseFloat(snapshot.average_rating)}
              snapshotId={snapshot.uuid}
              iconDimensions="10px"
              isAuthenticated={authenticated}
            />
          </div>}
        </div>
        <ImageLazyLoad src={snapshot.thumbnail} loaderProps={loaderProps} minHeight={99} className="img-fluid w-100"/>
      </div>
      {isContest && <div className="pt-2 text-right">
        <SnapshotRating
          rating={parseFloat(snapshot.average_rating)}
          snapshotId={snapshot.uuid}
          isAuthenticated={authenticated}
        />
      </div>}
    </div>
  );
};
